<template>
    <div class="fentotl">
          <el-pagination
          class="jiange"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="PageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
    </div>
</template>
<script>
export default {
    name:'paginaTion',
     props: {
         total: [String,Number], 
         type: [String,Number]
     },
    data () {
        return {
         totalNum:0,
        currentPage: 1, //初始页
        PageSize: 10, //每页的数据
        pageSizes:[10,20,30,40,50,100],
        }
    },
    methods: {
     handleSizeChange(val) {
       this.PageSize = val
       this.$emit('sendStatus', this.PageSize,'PageSize',this.type)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.$emit('sendStatus', this.currentPage,'currentPage',this.type)
    },
    },
}
</script>
<style lang="scss" scoped>
.jiange {
      margin-top: 20px;
    }
</style>